// import 'froala-editor/js/plugins.pkgd.min.js';
// //Import third party plugins
// import 'froala-editor/js/third_party/embedly.min';
// import 'froala-editor/js/third_party/font_awesome.min';
// import 'froala-editor/js/third_party/spell_checker.min';
// import 'froala-editor/js/third_party/image_tui.min';
// // Import Froala Editor css files.
// import 'froala-editor/css/froala_editor.pkgd.min.css';
// import 'froala-editor/css/froala_style.min.css';

//////////////////////////////////////////

// import { createApp } from "vue";
// import App from "./App.vue";
// import router from "./router";
// import PrimeVue from "primevue/config";
// import "primevue/resources/themes/saga-blue/theme.css";
// import "primevue/resources/primevue.min.css";
// import "primeicons/primeicons.css";
// import "./assets/styles/tailwind.css";
// import Tooltip from "primevue/tooltip";
// import VueSweetalert2 from "vue-sweetalert2";
// import "sweetalert2/dist/sweetalert2.min.css";
// import Chart from 'primevue/chart';
// import YouTube from 'vue3-youtube';
// import Vue3DraggableResizable from 'vue3-draggable-resizable'
// import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
// import VueGoogleMaps from '@fawmi/vue-google-maps'
// import draggable from "vuedraggable";
// // import VueFroala from 'vue-froala-wysiwyg';
// import fabric from 'fabric';

// createApp(App)
//   .use(router)
//   .use(PrimeVue)
//   .use(VueSweetalert2)
//   .use(Vue3DraggableResizable)
//   .use(draggable)
//   .use(fabric)
//   // .use(VueFroala)
//   .use(VueGoogleMaps, {
//       load: {
//           key: 'AIzaSyBMxcpHHv8U4kBGWF5aeK93FrbMj3TrVMk',
//       },
//   })
//   .component('Chart', Chart)
//   .component('YouTube', YouTube)
//   .directive("tooltip", Tooltip)
//   .mount("#app");

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import PrimeVue from "primevue/config";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "./assets/styles/tailwind.css";
import Tooltip from "primevue/tooltip";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Chart from 'primevue/chart';
import YouTube from 'vue3-youtube';
import Vue3DraggableResizable from 'vue3-draggable-resizable';
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import draggable from "vuedraggable";
// import VueFroala from 'vue-froala-wysiwyg';
import { fabric } from 'fabric';
import { plugin as VueTippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';

// 创建 Vue 应用实例
const app = createApp(App);

// 注册插件
app.use(router);
app.use(PrimeVue);
app.use(VueSweetalert2);
app.use(Vue3DraggableResizable);
app.use(draggable);
// app.use(VueFroala);
app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBMxcpHHv8U4kBGWF5aeK93FrbMj3TrVMk',
  },
});
app.use(VueTippy, {
  directive: 'tippy',
  component: 'tippy',
});

// 注册全局组件和指令
app.component('Chart', Chart);
app.component('YouTube', YouTube);
app.directive("tooltip", Tooltip);

// 将 fabric 添加到全局属性
app.config.globalProperties.$fabric = fabric;

// 挂载应用
app.mount("#app");

// console.log('main fabric');
// console.log(fabric);